const _state = {
  selectedSession: null,
  isRenderedReport: true,
  isCreatingNewSession: false,
  // Id of the presentation whose results are mid-reset (or null). Stays set for
  // the whole reset + refetch window (AHA-41694) — unlike isCreatingNewSession,
  // which clears as soon as the publish POST resolves. Keyed by id (not a bare
  // boolean) so presenting is blocked only for the presentation actually being
  // reset, and a stuck flag can't block unrelated presentations.
  resettingResultsPresentationId: null,
}

export default _state
